import customSelect from 'custom-select';

export default class Expert {

    static get selector() {
      return '.expert';
    }
    
    constructor(el) {
        this.el = el;
        this.options = this.getOptions();
        this.container = el.querySelector('.expert__container');
        this.selectEl = el.querySelector('.expert__navMobile');
        this.select = customSelect(this.selectEl);

        this.setEvents();
        this.activeFirst();
    }

    getOptions() {
        let selectors = this.el.querySelectorAll('.expert__navItem');
        let options = [];
        selectors.forEach( selector => {
            let option = {};
                option.selector = selector;
                option.id = selector.getAttribute('href');
                option.el = this.el.querySelector(option.id);
                option.isActive = false;
                option.otherLinks = this.getOtherLinks(option.id);
            options.push(option);
        });
        return options;
    }

    getOtherLinks(id) {
        let url = new URL(window.location.href);
        url.hash = id;
        let els = document.querySelectorAll("a[href='" + url.toString() + "']");


        return els;
    }

    activeFirst(){
        let url = new URL(window.location.href);
        this.active(this.options[0]);

        this.options.forEach(option => {

            if(option.id == url.hash){
                this.active(option);
            }
        })
    }


    activeHash(hash){
        this.options.forEach(option => {
            if(option.id == hash){
                this.active(option);
            }
        })
    }

    active(option) {
        if(option.isActive) return;
        this.desactiveAll();
        this.selectEl.value = option.id;

        option.selector.classList.add('expert__navItem--active');
        option.el.classList.add('expert__section--active');
        this.setMinHeight(option);
        option.isActive = true;
    }

    desactive(option) {
        if(!option.isActive) return;
        option.selector.classList.remove('expert__navItem--active');
        option.el.classList.remove('expert__section--active');
        option.isActive = false;
    }

    desactiveAll() {
        this.options.forEach( option => {
            if(option.isActive) {
                this.desactive(option);
            }
        });
    }

    setMinHeight(option) {
        this.container.style.minHeight = option.el.offsetHeight +'px';
    }

    /**
     * Events
     */
    setEvents() {
        this.options.forEach( option => {
            option.selector.addEventListener('click', (e) => { this.e_click(e, option); }, false);

            option.otherLinks.forEach( link => {
                link.addEventListener('click', (e) => {
                    this.active(option);
                });
            });
        });

        this.selectEl.addEventListener('change', (e) => {
            this.activeHash(e.target.value);
        })
    }

    e_click(e, option) {
        e.preventDefault();
        this.active(option);
    }

}
